import { capitalize as c } from "lodash-es"

export function capitalize<T extends string>(str: T): Capitalize<T> {
  return c(str) as Capitalize<T>
}
